import { render, staticRenderFns } from "./ClrmShareScreen.vue?vue&type=template&id=72477a6b&scoped=true&"
import script from "./ClrmShareScreen.vue?vue&type=script&lang=js&"
export * from "./ClrmShareScreen.vue?vue&type=script&lang=js&"
import style0 from "./ClrmShareScreen.vue?vue&type=style&index=0&id=72477a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72477a6b",
  null
  
)

export default component.exports